exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-flex[data-v-26da2481] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.days-text-icon[data-v-26da2481] {\n  -ms-flex-item-align: center;\n      align-self: center;\n  margin: 0px 8px;\n}\n.days-text-icon.md-warning > i[data-v-26da2481] {\n    color: #ff9800 !important;\n}\n", ""]);

// exports
